export function getValueOnRanges(value, param): any {
  for (let range in param) {
    let [from, to]: (number | string)[] = range.split('~')
    let from_defined = !!from
    let to_defined = !!to

    from = parseFloat(from)
    to = parseFloat(to)
    value = Number(value) || 0

    if (from_defined && !to_defined && value >= from) {
      return param[range]
    } else if (!from_defined && to_defined && value < to) {
      return param[range]
    }

    if (value >= from && value < to) {
      return param[range]
    }
  }

  return param['default']
}
